/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createVersion } from '../../factoriesAny.js';
export var versionDependencies = {
  createVersion: createVersion
};